<main class="max-w-lg mx-auto px-2">
  <div class="flex flex-col items-stretch justify-between shrink-0">
    <span class="text-right font-bold text-6xl">anonroom</span>

    <p class="py-3">
      I created anonroom because I wanted to experiment with <a
        href="https://github.com/fiatjaf/nostr" class="underline">Nostr</a
      >. It's an interesting experiment, for sure, but I don't see any useful
      discussion here. Since this chat room is anonymous, people can be dicks
      without facing the consequences, which I have no interest in dealing with.
    </p>

    <p>
      This lil' app (site) is retired. If you'd like to run anonroom, fork the
      <a href="https://github.com/vinliao/anonroom" class="underline">project</a
      > and go back one commit. Have a great day.
    </p>
  </div>
</main>
